// The test-mode marker (CLAUDE.md: the data layer, testing before launch).
//
// With the test code, the site plays puzzles that are still in the queue, and
// results from those plays are marked as tests and wiped at launch. A screen in
// that state must never be mistaken for the real site, so it says so, in the
// top-right corner, on every page. The code exists only in the development
// server and Cloudflare preview builds (vite.config.ts); in production
// TEST_MODE is false and this renders nothing.
//
// **On a development build it is also the switch for the development bar** on a
// phone held sideways, where the bar has nowhere to sit that does not cover the
// game or push the header's title off the centre: tap the badge and the bar
// opens below it (`data-dev-open` on the root, PreviewBadge.css). Upright and on
// a desktop the bar is always showing and the tap does nothing visible.
import { useEffect, useState } from 'react';
import { TEST_MODE } from '../lib/api.ts';
import { DEV } from '../dev/preview.ts';
import './TestBadge.css';

const TITLE = 'Queued puzzles, playable before launch. Results here are marked as tests.';

export function TestBadge() {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (DEV) document.documentElement.toggleAttribute('data-dev-open', open);
  }, [open]);
  if (!TEST_MODE) return null;
  if (DEV) {
    return (
      <button type="button" className="test-badge" title={`${TITLE} Tap to show the development bar.`}
              aria-expanded={open} onClick={() => setOpen((o) => !o)}>Test mode</button>
    );
  }
  return <p className="test-badge" title={TITLE}>Test mode</p>;
}
